// App.tsx
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import { UserProvider } from "./context/UserContext";
import { NotificationsProvider } from "./context/NotificationsContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { SvgBackground } from "./components/SvgBackground";
import "./index.css";
import { useTimeZoneSyncWithBanner } from "./hooks/useTimeZoneSyncWithBanner";

const UserDocumentsPage = lazy(() => import("./pages/UserDocumentsPage"));
const ExercicesPage = lazy(() => import("./pages/ExercicesPage"));
const HomePage = lazy(() => import("./pages/HomePage"));
const UserProfile = lazy(() => import("./pages/UserProfile"));
const QuestionnairePage = lazy(() => import("./pages/Questionnaire"));
const ResultsPage = lazy(() => import("./pages/ResultsPage"));
const About = lazy(() => import("./pages/About"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const CGU = lazy(() => import("./pages/CGU"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const AdminRoute = lazy(() => import("./routes/AdminRoute"));

function App() {
  // 🔥 Active la détection + bannière (écart >= 2h)
  useTimeZoneSyncWithBanner({ thresholdHours: 2 });

  return (
    <UserProvider>
      <NotificationsProvider>
      <ToastContainer />
      <Router basename="/app">
        <div className="flex flex-col min-h-screen">
          <header className="shrink-0">
            <Navbar />
          </header>

          <SvgBackground />

          <main className="flex-1">
            <Suspense fallback={<div className="min-h-[40vh] grid place-items-center text-xs font-bold uppercase tracking-widest text-yellow-400">Chargement…</div>}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/profile" element={<UserProfile />} />
                <Route path="/questionnaire" element={<QuestionnairePage />} />
                <Route path="/documents" element={<UserDocumentsPage />} />
                <Route path="/exercices" element={<ExercicesPage />} />
                <Route path="/resultat/:id" element={<ResultsPage />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cgu" element={<CGU />} />
                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <AdminPage />
                    </AdminRoute>
                  }
                />
              </Routes>
            </Suspense>
          </main>

          <Footer />
        </div>
      </Router>
      </NotificationsProvider>
    </UserProvider>
  );
}

export default App;
